<template>
  <div class="home-skeleton">
    <div class="item" v-for="i in 8" :key="i" :style="{ backgroundColor: bg }">
      <shSkeleton bg="#e4e4e4" width="245px" height="200px" animated />
      <shSkeleton bg="#e4e4e4" width="230px" height="35px" animated />
      <shSkeleton bg="#e4e4e4" width="120px" height="24px" animated />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  width: 995px;
  height: 305px;
  display: flex;
  flex-wrap: wrap;
  margin-left: 245px;
  justify-content: space-between;
  position: absolute;

  .item {
    width: 245px;
    height: 305px;
    .sh-skeleton ~ .sh-skeleton {
      display: block;
      margin: 10px auto 0;
    }
  }
}
</style>
